import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./AllCompanyClient.css";

const AllCompanyClient = ({ clients = [], title }) => {
  return (
    <div className="client-section">
      {title && <h2 className="client-title">{title}</h2>}
      <hr className="client-SectionLine" />

      <div className="client-slider-wrapper">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={5}
          loop={true}
          centeredSlides={false}
          navigation
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            1024: { slidesPerView: 5 },
            768: { slidesPerView: 3 },
            480: { slidesPerView: 2 },
          }}
        >
          {clients.map((client, index) => (
            <SwiperSlide key={index} className="client-slide">
              <img
                src={client.url}
                alt={client.title || `Client ${index + 1}`}
                className="client-logo"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default AllCompanyClient;
